import { WebsiteLevel } from "../types/WebsiteConfig"
import { ListingCategory, ListingStatus, PropertyType, PropertyCategory, PropertySubCategory, MethodOfSale } from "../types/Listing";
import { Config } from "../services/Config";
import { OrderByStatement } from "../types";

enum ListingOrderBy {
    SoldDateAsc = "SoldDate:Asc",
    SoldDateDesc = "SoldDate:Desc",

    CreateDateAsc = "CreateDate:Asc",
    CreateDateDesc = "CreateDate:Desc",

    SalePriceAsc = "SalePrice:Asc",
    SalePriceDesc = "SalePrice:Desc",

    SoldPriceAsc = "SoldPrice:Asc",
    SoldPriceDesc = "SoldPrice:Desc",

    SuburbAsc = "Suburb:Asc",
    SuburbDesc = "Suburb:Desc",

    LastUpdatedDateAsc = "LastUpdatedDate:Asc",
    LastUpdatedDateDesc = "LastUpdatedDate:Desc"
}

class ListingFilter {
    SearchLevel: WebsiteLevel = Config.API.WebsiteLevel;
    SearchGuid: string = Config.API.WebsiteId;
    SearchGuids: string[] = [];

    Page: number = 1;
    PageSize: number = 10;

    ExcludeConjunctionalListings: boolean = false;
    IsHighlightListing: boolean = false;
    IsFeatured: boolean = false;
    IsPROListFeatured: boolean = false;
    HaveInspections: boolean = false;
    
    PropertyId: string | string = '';
    Estate: string | string = '';

    Categories: ListingCategory[] = [];
    Statuses: ListingStatus[] = [];
    PropertyTypes: PropertyType[] = [];
    PropertyCategories: PropertyCategory[] = [];
    PropertySubCategories: PropertySubCategory[] = [];
    MethodsOfSale: MethodOfSale[] = [];

    AddressString: string | string = '';
    LotNumber: string | string = '';
    UnitNumber: string | string = '';
    StreetNumber: string | string = '';
    Suburbs: string[] = [];

    BoundsNorth: number | string = '';
    BoundsEast: number | string = '';
    BoundsSouth: number | string = '';
    BoundsWest: number | string = '';

    OrderByStatements: ListingOrderBy[] | OrderByStatement[] = [];

    MinBedrooms: number | string = '';
    MinBathrooms: number | string = '';
    MinParking: number | string = '';

    MinLandArea: number | string = '';
    MaxLandArea: number | string = '';

    MinPrice: number | string = '';
    MaxPrice: number | string = '';

    MinSoldPrice: number | string = '';
    MaxSoldPrice: number | string = '';

    constructor(init?: Partial<ListingFilter>) {
        if(init) Object.assign(this, init);
    }
}

export { ListingFilter, ListingOrderBy }
